var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EEFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7083 9.0835H14.2916C11.4151 9.0835 9.08325 11.4153 9.08325 14.2918V24.7085C9.08325 27.585 11.4151 29.9168 14.2916 29.9168H24.7083C27.5847 29.9168 29.9166 27.585 29.9166 24.7085V14.2918C29.9166 11.4153 27.5847 9.0835 24.7083 9.0835Z",
    stroke: "#00BF62",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 18.8436C23.7952 19.7105 23.6472 20.5959 23.2435 21.3738C22.8399 22.1517 22.2012 22.7825 21.4184 23.1766C20.6355 23.5706 19.7484 23.7077 18.8831 23.5685C18.0179 23.4293 17.2185 23.0207 16.5988 22.401C15.9791 21.7813 15.5706 20.982 15.4313 20.1167C15.2921 19.2514 15.4293 18.3643 15.8233 17.5815C16.2173 16.7986 16.8481 16.16 17.626 15.7563C18.404 15.3527 19.2893 15.2046 20.1563 15.3332C21.0406 15.4643 21.8592 15.8764 22.4914 16.5085C23.1235 17.1406 23.5356 17.9593 23.6667 18.8436Z",
    stroke: "#00BF62",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2292 13.771H25.2397",
    stroke: "#00BF62",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaicon);
export default __webpack_public_path__ + "static/media/instaicon.412652ca2a70e88cc60ef8076a9d28b3.svg";
export { ForwardRef as ReactComponent };